import React, { useState, useEffect, lazy, Suspense } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Aviva_logo from "../assets/Home/Aviva.png";
import Zurich_logo from "../assets/Home/Zurich.png";
import AON_logo from "../assets/Home/AON.png";
import ITC_logo from "../assets/Home/ITC.png";
import Brokers_ireland from "../assets/Home/brokers_ireland.png";
import Royal_london from "../assets/Home/Royal_london.png";
import Standard_life from "../assets/Home/standard_life.png";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons/faLightbulb";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faChartLine } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons/faClipboardCheck";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons/faShieldAlt";
import { faUserShield } from "@fortawesome/free-solid-svg-icons/faUserShield";
import { faRocket } from "@fortawesome/free-solid-svg-icons/faRocket";
import { faPiggyBank } from "@fortawesome/free-solid-svg-icons/faPiggyBank";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faHandshake } from "@fortawesome/free-solid-svg-icons/faHandshake";
import { faPeopleArrows } from "@fortawesome/free-solid-svg-icons/faPeopleArrows";
import ContactForm from "../ContactForm/ContactForm";
const DownloadContactModals = lazy(() => import("./DownloadContactModals"));
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import PensionImg from "../assets/Home/HomePension.png";
import FullFinancialReviewImg from "../assets/Home/HomeFullFinancialReview.png";
import InvestmentImg from "../assets/Home/investmentportfolio.png";
import ProtectionImg from "../assets/Home/HomeProtection.png";
import MortgageProtectionImg from "../assets/Home/HomeMortgageProtection.png";
import IncomeProtectionImg from "../assets/Home/HomeIncomeProtection.png";
import "./Home.css";
import trustPilotLogo from "../assets/trustpilot-transparent-logo.png";
import trustPilotStars from "../assets/trust_pilot_stars.png";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const navigate = useNavigate();
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const handleDownloadClick = () => {
    setShowDownloadModal(true);
  };

  const [showHeroVideo, setShowHeroVideo] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(() => setShowHeroVideo(true));
      } else {
        setShowHeroVideo(true);
      }
    }, 600);
    return () => clearTimeout(timeout);
  }, []);

  const partners = [
    Aviva_logo,
    Zurich_logo,
    AON_logo,
    ITC_logo,
    Standard_life,
    Royal_london,
  ];

  const handleConfirmDownload = () => {
    setShowDownloadModal(false);
    setShowContactModal(true);
  };

  const handleFormSuccess = () => {
    setShowContactModal(false);
    window.open(
      "https://documents.apollofinancial.ie/Learning%20Material/15%20Minute%20Plan%20Retirement.pdf",
      "_blank"
    );
  };

  const handleFreeConsultant = () => {
    setShowDownloadModal(false);
    navigate("/contact/");
    setTimeout(() => {
      const element = document.getElementById("get-in-touch");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const handleCancelDownload = () => {
    setShowDownloadModal(false);
    window.open(
      "https://documents.apollofinancial.ie/Learning%20Material/15%20Minute%20Plan%20Retirement.pdf",
      "_blank"
    );
  };

  // const [userInteracted, setUserInteracted] = useState(false);
  // const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  // const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  // const videos = [
  //   homevideo1,
  //   homevideo2,
  //   // homevideo3,
  //   homevideo4,
  //   homevideo5,
  //   homevideo6,
  //   homevideo7,
  //   homevideo8,
  //   homevideo9,
  //   homevideo10,
  //   homevideo11,
  // ];

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  //     setIsVideoLoaded(false);
  //   }, 8000); // Change video every 8 seconds

  //   return () => clearInterval(interval);
  // }, []);

  const services = [
    {
      id: "financial-review",
      link: "/services/financial-review/",
      img: FullFinancialReviewImg,
      title: "Full Financial Review",
      points: [
        "✔ Get a 360° view of your financial health.",
        "✔ Identify growth opportunities and minimise risks.",
        "✔ Receive personalised recommendations backed by expert analysis.",
      ],
      className: "",
    },
    {
      id: "pension",
      link: "/services/pension/",
      img: PensionImg,
      title: "Pension & Retirement Planning",
      points: [
        "✔ Consolidate all your pensions in one place.",
        "✔ Start a new pension plan and stay on track for retirement.",
        "✔ Secure your retirement with pension term assurance plans.",
      ],
      className: "gray",
    },
    {
      id: "life-protection",
      link: "/services/life-protection/",
      img: ProtectionImg,
      title: "Life Protection",
      points: [
        "✔ We help you figure out the right amount of life insurance so your loved ones are protected if something unexpected happens.",
        "✔ We shop around to find the best life insurance options that fit your needs and budget.",
        "✔ We’re here to support you as your life changes, making sure your policy always matches your current situation.",
      ],
      className: "",
    },
    {
      id: "mortgage-protection",
      link: "/services/life-protection/",
      img: MortgageProtectionImg,
      title: "Mortgage Protection",
      points: [
        "✔ Ensure your home remains protected in case of unforeseen events.",
        "✔ Access to top providers with great discounts.",
        "✔ Support for medical declines and lender negotiations.",
      ],
      className: "gray",
    },
    {
      id: "income-protection",
      link: "/services/life-protection/",
      img: IncomeProtectionImg,
      title: "Income Protection",
      points: [
        "✔ We take the time to understand your job, lifestyle, and financial needs so we can find the right income protection for you.",
        "✔ We’ll explain everything in plain English, so you know exactly what your cover includes—no confusing jargon.",
        "✔ We regularly review your policy to ensure it evolves with your changing lifestyle, so you can focus on growing your income, not worrying about your coverage.",
      ],
      className: "",
    },
    {
      id: "investments",
      link: "/services/investments/",
      img: InvestmentImg,
      title: "Investments",
      points: [
        "✔ Start a new investment tailored to your goals.",
        "✔ Monitor and optimise your portfolio with real-time insights.",
        "✔ Diversify your assets to build long-term financial resilience.",
      ],
      className: "gray",
    },
  ];

  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } },
  };

  const [heroRef, heroInView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Memoized service card
  const ServiceCard = React.memo(
    ({
      service,
      scrollToTop,
    }: {
      service: (typeof services)[0];
      scrollToTop: () => void;
    }) => (
      <div className="services-grid">
        <Link
          to={service.link}
          className={`service-card ${service.className}`}
          onClick={scrollToTop}
        >
          <img
            src={service.img}
            alt={`${service.title} service - Apollo Financial Services`}
          />
          <h3>{service.title}</h3>
          {service.points.map((point, index) => (
            <p key={index}>{point}</p>
          ))}
        </Link>
      </div>
    )
  );

  // Memoize the mapped slider items
  const serviceCards = React.useMemo(
    () =>
      services.map((service) => (
        <ServiceCard
          key={service.id}
          service={service}
          scrollToTop={scrollToTop}
        />
      )),
    [services]
  );

  const handleSuccess = () => {
    console.log("Form submitted successfully from Home page");
  };

  const handleError = (error: Error) => {
    console.error("Form submission error from Home page:", error);
  };

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    waitForAnimate: false,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="home">
      <Helmet>
        <title>Apollo Financial Services</title>
        <meta
          name="description"
          content="Apollo Financial Services provides comprehensive financial planning, pension advice, investment strategies, and protection solutions in Ireland. Get expert financial advice today."
        />
        <meta
          name="keywords"
          content="financial advisor Ireland, certified financial planner, independent financial advisor, fiduciary financial advisor, wealth management Ireland, investment advisor, retirement planning Ireland, financial consultant, personal finance advisor, financial planning services, financial advisor Dublin, financial planner Cork, wealth management Galway, investment advisor Limerick, retirement planning Waterford, financial consultant Kilkenny, personal finance advisor Sligo, financial planning services Wexford, independent financial advisor Kildare, fiduciary financial advisor Meath, pension advice Ireland, investment planning, tax planning services, estate planning advisor, mortgage advice Ireland, college savings plans, retirement income strategies, wealth preservation strategies, financial risk assessment, debt management advisor, financial literacy programs Ireland, retirement calculators, investment risk assessment tools, financial planning workshops, online financial advisory services, virtual financial consultations, financial goal setting, budgeting tools Ireland, saving strategies for young professionals, financial planning for families, financial advisor cost, best financial advisors near me, fee-only financial planner, wealth management consultant, financial advisory services, personal financial planning, financial planning for retirement, investment management services, financial planning for business owners, financial planning for expats"
        />
        <meta
          property="og:title"
          content="Apollo Financial Services | Expert Financial Planning in Ireland"
        />
        <meta
          property="og:description"
          content="Empowering your financial journey with expert guidance. Tailored solutions for individuals and businesses in Ireland."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.apollofinancial.ie" />
        <link rel="canonical" href="https://www.apollofinancial.ie" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FinancialService",
            name: "Apollo Financial Services",
            logo: "https://www.apollofinancial.ie/src/assets/Home/logo2.jpg",
            description:
              "Providing expert financial planning and advisory services in Ireland",
            url: "https://www.apollofinancial.ie",
            sameAs: [
              "https://www.facebook.com/ApolloFinancialServicesLtd",
              "https://www.linkedin.com/company/apollo-financial-services-limited/",
            ],
            address: {
              "@type": "PostalAddress",
              streetAddress: "Thomastown House, Thomastown",
              addressLocality: "Duleek",
              addressRegion: "Co. Meath",
              postalCode: "A92 X362",
              addressCountry: "IE",
            },
            telephone: "+353 1 689 5066",
            email: "info@apollofinancial.ie",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Home",
            url: "https://www.apollofinancial.ie/",
            description:
              "Apollo Financial Services is Ireland's trusted financial advisor for pensions, investments, and protection planning. Start your financial journey with expert advice.",
          })}
        </script>
      </Helmet>
      <motion.section
        ref={heroRef}
        className="hero"
        initial="hidden"
        animate={heroInView ? "visible" : "hidden"}
        variants={fadeInVariants}
        aria-label="Welcome to Apollo Financial Services"
      >
        <div className="hero-container">
          <div className="hero-video-container">
            {showHeroVideo && (
              <video
                className="hero-video"
                autoPlay
                loop
                muted
                playsInline
                disablePictureInPicture
                controls={false}
                preload="none"
                title="Apollo Financial Services Introduction"
                aria-label="Financial planning services overview"
              >
                {showHeroVideo && (
                  <>
                    <source
                      src="https://documents.apollofinancial.ie/website-videos/website_home_video.webm"
                      type="video/webm"
                    />
                    <source
                      src="https://documents.apollofinancial.ie/website-videos/01-05-2025-4k%20website%20video%20.mp4"
                      type="video/mp4"
                    />
                  </>
                )}
                Your browser does not support the video tag.
              </video>
            )}
            <div className="home-hero-overlay"></div>
          </div>
          <motion.div
            className="hero-content"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            aria-labelledby="main-heading sub-heading"
          >
            <h1 id="main-heading">
              Welcome to
              <br aria-hidden="true" />
              Apollo Financial Services
              <br aria-hidden="true" />
            </h1>
            <h2 id="sub-heading">Your Smart Financial Partner</h2>
            <p>
              Empowering your financial journey with expert guidance. Tailored
              solutions for individuals and businesses. Driven by integrity,
              built on trust. Your goals, our mission.
            </p>
            <div className="icon-text" role="list">
              <span className="icon-item" role="listitem">
                <FontAwesomeIcon icon={faLightbulb} aria-hidden="true" />{" "}
                Actionable Insights
              </span>
              <span className="icon-item">
                <FontAwesomeIcon icon={faChartLine} aria-hidden="true" />{" "}
                Seamless Investing
              </span>
              <span className="icon-item">
                <FontAwesomeIcon icon={faCheckCircle} aria-hidden="true" />{" "}
                Trusted Guidance
              </span>
            </div>
          </motion.div>
        </div>
      </motion.section>
      <section className="services">
        {/* <div className="banner">
          <div className="banner-content">
            <h1>Empower Your Financial Future with AI</h1>
            <p>
              ✔ Get instant, data-driven financial advice tailored to your
              needs.
            </p>
            <p>
              ✔ Our AI Advisor simplifies complex decisions, helping you secure
              your future effortlessly.
            </p>
            <Link to="/sign-up" className="get-started-btn">
              Get Started
            </Link>
          </div>
          <img
            src={AI_Banner}
            alt="AI Financial Advisor"
            className="banner-image"
          />
        </div> */}
        <h2>Our Services</h2>
        <div className="services-container">
          <div>
            <Suspense fallback={<div>Loading slider...</div>}>
              <Slider {...sliderSettings} aria-label="Our financial services">
                {serviceCards}
              </Slider>
            </Suspense>
          </div>
        </div>
        <div className="home-contact-container">
          <div className="home-contact-content">
            <div className="welcome-section">
              <div className="welcome-section-first-div">
                <div className="section-video">
                  <video
                    className="guide-section-video"
                    autoPlay
                    loop
                    playsInline
                    disablePictureInPicture
                    controls
                    controlsList="nodownload nofullscreen noplaybackrate"
                    preload="auto"
                    title="Guide Section"
                    aria-label="CEO Overview"
                    id="myVideo"
                  >
                    <source
                      src="https://documents.apollofinancial.ie/website-videos/guide_video_home.webm"
                      type="video/webm"
                    />
                    <source
                      src="https://documents.apollofinancial.ie/website-videos/Guide_section_video.mp4"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                  {/* )} */}
                </div>
              </div>
              <div className="content-welcome-section-div">
                <h2 className="get-in-guide">We are here to guide you!</h2>
                <h2 className="donwload-guide">DOWNLOAD YOUR FREE GUIDE</h2>
                <p>Want to Talk About Your Financial Situation?</p>
                <p>
                  We're here to help. Before booking your consultation, feel
                  free to explore our free financial guide and see what our
                  customers have to say about their experience with us.
                </p>
                <div className="welcome-buttons">
                  <button
                    className="download-guide-btn"
                    onClick={handleDownloadClick}
                  >
                    Download free guide
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      style={{ marginTop: "4px" }}
                    />
                  </button>
                  <button
                    className="consultation-btn"
                    onClick={handleFreeConsultant}
                  >
                    Book my free consultation
                  </button>
                </div>
                <div className="custom-trustpilot">
                  <div className="trustpilot-header">
                    {" "}
                    <span className="glowing-star">🌟</span> Rated Excellent on
                    <img
                      src={trustPilotLogo}
                      alt="Trustpilot logo"
                      className="trustpilot-logo"
                    />Trustpilot
                  </div>

                  <div className="trustpilot-body">
                    <div className="trustpilot-rating">
                      <img
                        src={trustPilotStars}
                        alt="Trustpilot logo"
                        className="trustpilot-logo-stars"
                      />{" "}
                      4.8/5
                    </div>
                  </div>

                  <a
                    href="https://www.trustpilot.com/review/apollofinancial.ie"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="trustpilot-link"
                  >
                    👉 Read our reviews on Trustpilot
                  </a>
                </div>
              </div>
            </div>
            <div className="contact-form-section">
              <h2 className="get-in-touch">Get in Touch</h2>
              <ContactForm onSuccess={handleSuccess} onError={handleError} />
            </div>
          </div>
        </div>
      </section>

      <section className="about-how">
        <h2 style={{ paddingTop: "2rem", marginBottom: "0.5rem" }}>
          Apollo Financial Services are proud member of
        </h2>
        <div className="how-grid-img">
          <img src={Brokers_ireland} alt="Brokers Ireland" />
        </div>
      </section>
      <section className="about-how">
        <h2 style={{ paddingTop: "2rem", marginBottom: "0.5rem" }}>
          How Apollo Financial Services Works
        </h2>
        <div className="how-grid">
          <div className="how-card">
            <FontAwesomeIcon icon={faLightbulb} className="icon" />
            <h3>Understanding Your Goals</h3>
            <p>
              Our advisors analyse your financial status, understand your goals,
              and create a personalised plan tailored to your ambitions.
            </p>
          </div>
          <div className="how-card">
            <FontAwesomeIcon icon={faHandshake} className="icon" />
            <h3>Creating a Customised Strategy</h3>
            <p>
              Whether you need{" "}
              <strong>
                Full Financial Review, Pension & Retirement Planning, Life &
                Protection, or Investments
              </strong>
              , we craft tailored strategies suited to your specific financial
              goals.
            </p>
          </div>
          <div className="how-card">
            <FontAwesomeIcon icon={faRocket} className="icon" />
            <h3>Execution & Support</h3>
            <p>
              Our advisors implement your strategy, continuously monitoring and
              adjusting to market trends for optimal results.
            </p>
          </div>
          <div className="how-card">
            <FontAwesomeIcon icon={faPeopleArrows} className="icon" />
            <h3>Progress Tracking</h3>
            <p>
              We don’t just set your plan in motion — we stay with you, we
              provide regular reviews, proactive updates, and ongoing support to
              ensure your financial strategy evolves with your life and goals.
            </p>
          </div>
        </div>
      </section>

      <section className="about-how">
        <h2 style={{ paddingTop: "2rem", marginBottom: "0.5rem" }}>
          Partners of Apollo Financial Services
        </h2>
        <div className="partner-marquee">
          <div className="partner-track">
            {[...partners, ...partners].map((logo, index) => {
              const isAON = logo === AON_logo;
              const isRoyalLondon = logo === Royal_london;
              return (
                <div
                  className={`partner-logo ${isAON ? "aon-logo" : ""} ${
                    isRoyalLondon ? "royal-london-logo" : ""
                  }`}
                  key={index}
                  style={{ "--i": index } as React.CSSProperties}
                >
                  <img src={logo} alt={`Partner ${index + 1}`} />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* How We Help */}
      <section className="about-help">
        <h2>How We Help You</h2>
        <div className="help-grid">
          <div className="help-card">
            <FontAwesomeIcon icon={faChartLine} className="icon" />
            <h3>Full Financial Planning</h3>
            <p>
              Our advisors provide{" "}
              <strong>personalised financial roadmaps</strong> that align with
              your income, expenses, and long-term aspirations.
            </p>
          </div>
          <div className="help-card">
            <FontAwesomeIcon icon={faShieldAlt} className="icon" />
            <h3>Retirement & Pension Plans</h3>
            <p>
              We ensure your <strong>financial security post-retirement</strong>{" "}
              with customised pension and savings plans.
            </p>
          </div>
          <div className="help-card">
            <FontAwesomeIcon icon={faPiggyBank} className="icon" />
            <h3>Life & Protection</h3>
            <p>
              We help safeguard you and your loved ones with{" "}
              <strong>
                Life Insurance, Mortgage Protection, Income Protection, and
                Pension Term Assurance
              </strong>
              , ensuring financial stability in uncertain times.
            </p>
          </div>
          <div className="help-card">
            <FontAwesomeIcon icon={faPiggyBank} className="icon" />
            <h3>Investment Management</h3>
            <p>
              We offer <strong>smart investment strategies</strong> to help you
              grow your wealth through diversified and risk-balanced portfolios.
            </p>
          </div>
        </div>
      </section>
      <section className="why-finwise">
        <h2>Why Apollo Financial Services?</h2>
        <ul>
          <li>
            <FontAwesomeIcon icon={faChartLine} />
            Invest with confidence – Start, manage, and grow your wealth with
            ease.
          </li>
          <li>
            <FontAwesomeIcon icon={faUserShield} /> We are regulated by the
            Central Bank of Ireland, and our team of fully qualified financial
            advisors is here to offer you trusted, expert financial guidance
            every step of the way.
          </li>
          <li>
            <FontAwesomeIcon icon={faClipboardCheck} /> Total financial clarity
            – Track and optimise your future with real-time insights.
          </li>
          <li>
            <FontAwesomeIcon icon={faShieldAlt} /> Security & transparency –
            Industry-leading protection for your peace of mind.
          </li>
        </ul>
      </section>
      {(showDownloadModal || showContactModal) && (
        <Suspense fallback={null}>
          <DownloadContactModals
            showDownloadModal={showDownloadModal}
            showContactModal={showContactModal}
            setShowDownloadModal={setShowDownloadModal}
            setShowContactModal={setShowContactModal}
            handleConfirmDownload={handleConfirmDownload}
            handleCancelDownload={handleCancelDownload}
            handleFormSuccess={handleFormSuccess}
          />
        </Suspense>
      )}
    </div>
  );
};

export default Home;
